import {
  createContext,
  PropsWithChildren,
  useCallback,
  useMemo,
  useState,
} from "react";

import { AutoScrollType } from "./AutoScrollContext.decl";

export const AutoScrollContext = createContext<AutoScrollType>(
  {} as AutoScrollType
);

export function AutoScrollProvider({ children }: PropsWithChildren) {
  const [autoScrollEnabled, setAutoScroll] = useState(false);

  const activate = useCallback(() => setAutoScroll(true), [setAutoScroll]);
  const disable = useCallback(() => setAutoScroll(false), [setAutoScroll]);

  const context = useMemo(
    () => ({ autoScrollEnabled, activate, disable, setAutoScroll }),
    [autoScrollEnabled, activate, disable]
  );

  return (
    <AutoScrollContext.Provider value={context}>
      {children}
    </AutoScrollContext.Provider>
  );
}
